<template>
    <div class="page-content">

        <div id="careers" class="section grow">
            <div class="overlay opacity-50"></div>
            <lottie-player
                autoplay
                loop
                mode="normal"
                preserveAspectRatio="xMidYMid slice"
                src="https://cdn.sleepjar.com/sleepsounds/images/backgrounds/7x3/animated/simple/json/StarryMountains.json"
                class="bg-lottie-player"
            />
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">

                        <h1 class="title color-white mb-5">Link to Alexa</h1>

                        <p class="lead mb-5">Unlock more free content and features by linking your Sleep Jar account to Alexa.</p>

                        <div class="section-title col-lg-12 col-md-12 ml-auto mr-auto mb-10">
                            <div class="table-responsive align-items-center text-right">
                                <table class="table table-striped premium-comparison-table">
                                    <thead>
                                        <tr>
                                            <th scope="col" class="text-right"></th>
                                            <th scope="col" class="text-center">
                                                <span class="d-block">Free</span>
                                            </th>
                                            <th scope="col" class="text-center premium-highlight">
                                                <span class="d-block">Linked to Alexa</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Sounds</td>
                                            <td>{{ freeCounts.SOUND }}</td>
                                            <td class="premium-highlight">{{ linkedCounts.SOUND }}</td>
                                        </tr>
                                        <tr>
                                            <td>Stories</td>
                                            <td>{{ freeCounts.STORY }}</td>
                                            <td class="premium-highlight">{{ linkedCounts.STORY }}</td>
                                        </tr>
                                        <tr>
                                            <td>Meditations</td>
                                            <td>{{ freeCounts.MEDITATION }}</td>
                                            <td class="premium-highlight">{{ linkedCounts.MEDITATION }}</td>
                                        </tr>
                                        <tr>
                                            <td>Journeys</td>
                                            <td>{{ freeCounts.JOURNEY }}</td>
                                            <td class="premium-highlight">{{ linkedCounts.JOURNEY }}</td>
                                        </tr>
                                        <tr>
                                            <td>New Content Releases</td>
                                            <td>Rarely</td>
                                            <td class="premium-highlight">Occasionally</td>
                                        </tr>
                                        <tr>
                                            <td>Synchronized Listening History</td>
                                            <td><i class="fas fa-times text-danger"></i></td>
                                            <td class="premium-highlight"><i class="fas fa-check text-success"></i></td>
                                        </tr>
                                        <tr>
                                            <td>Cross-Platform Premium Access</td>
                                            <td><i class="fas fa-times text-danger"></i></td>
                                            <td class="premium-highlight"><i class="fas fa-check text-success"></i></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <p class="lead mb-3">Install Sleep Jar for Android or iPhone today to Link to Alexa!</p>

                        <div class="row text-center mb-3">
                            <div class="col-md-12 mx-auto">
                                <a :href="$root.app_link.android" target="_blank" class="btn btn-lg btn-light"><i class="fab mr-2 fa-android"></i>Install Sleep Jar for Android</a>
                            </div>
                        </div>

                        <div class="row text-center mb-10">
                            <div class="col-md-12 mx-auto">
                                <a :href="$root.app_link.ios" target="_blank" class="btn btn-lg btn-light"><i class="fab mr-2 fa-apple"></i>Install Sleep Jar for iPhone</a>
                            </div>
                        </div>

                         <p class="lead mt-5"><small class="opacity-50">Geographic restrictions may apply. Check the Android or iOS app store for app availability in your country.</small></p>

                        

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import media from '../assets/media.js';
export default {
    data () {
        return {
            media
        };
    },
    name: 'alexa-link',
    metaInfo: {
        title: 'Link to Alexa',
        meta: [
            {
                'name': 'description',
                'property': 'og:description',
                'content': 'Link your Sleep Jar account to Amazon Alexa for the best cross-platform experience.'
            }
        ]
    },
    methods: {
        countMediaByTier(maxTier) {
            const counts = { SOUND: 0, STORY: 0, MEDITATION: 0, JOURNEY: 0 };
            Object.values(this.media).forEach(item => {
                if ((!item.published_ts || new Date(item.published_ts).getTime() < new Date().getTime()) && item.tier < maxTier && counts[item.type] !== undefined) {
                    counts[item.type]++;
                }
            });
            return counts;
        },
    },
    computed: {
        freeCounts() {
            return this.countMediaByTier(2);
        },
        linkedCounts() {
            return this.countMediaByTier(4);
        },
        premiumCounts() {
            return this.countMediaByTier(6); // 6 to include all (tier <= 5)
        }
    },
    components: {
    },
    mounted(){
    }
}
</script>
